import utils from './utils'

// https://greensock.com/docs/v3/Installation
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const dataAttrSuffix = 'parallax-section'
const dataAttr = 'data-' + dataAttrSuffix

const getAttributeObject = function(str='') {
  // jquery .data() requires a data-name='{"name": "value"}' pattern, not good for minification
  const dataString = str.replace(/'/g, '"')
  let obj = {}
  try {
    obj = JSON.parse(dataString)
  } catch (e) {
    console.log(e)
  } finally {
    return obj
  }
}

class ParallaxSection {
  constructor(target, args = {index: 0}) {
    this.target = target
    this.$el = $(this.target)
    this.tl = null
    this.$items = []

    this.id = dataAttrSuffix + '-' + args.index
    if(this.$el.attr('id')) {
      this.id = this.$el.attr('id')
    } else {
      this.$el.attr('id', this.id)
    }
    this.init()
  }

  init() {
    const params_default = {
      trigger: "#" + this.id,
      start: "top top", // 50 "top bottom"
      end: "bottom top", // "+=500"
      scrub: true,
      //onToggle: self => console.log("toggled, isActive:", self.isActive),
    }
    let params = {}
    if(this.$el.attr(dataAttr)) {
      params = Object.assign({}, params_default, getAttributeObject(this.$el.attr(dataAttr)))
    } else {
      params = Object.assign({}, params_default)
    }

    this.tl = gsap.timeline({
      scrollTrigger: params
    })

    //gsap.utils.toArray("#" + this.id + " [' + dataAttr + '-item]")
    this.$items = this.$el.find('[' + dataAttr + '-item]')
    //this.$items.forEach(layer => {
    const delta = 500 // (this.target.offsetHeight - layer.offsetHeight)
    this.$items.each((index, layer) => {
      layer.style.top = (this.target.offsetTop + 40 ) + 'px'
      const depth = layer.dataset.depth
      const movement = -(delta * depth)
      this.tl.to(layer, {y: movement, ease: "none"}, 0)
    })
  }
  destroy() {
    /*
    Kills the ScrollTrigger instance, immediately unpinning and restoring any pin-related changes made to the DOM by ScrollTrigger and removing all scroll-related listeners, etc. so that the instance is eligible for garbage collection.
    */
    if (this.tl) {
      this.tl.scrollTrigger.kill()
      this.tl.kill()
    }
  }
}

let sectionParallaxInstances = []

/*
let windowHg = 0
let windowWd = 0
const onWindowResize = function(){
	windowHg = $(window).height()
	windowWd = $(window).width()
}
const onWindowResizeThrottle = utils.throttle(onWindowResize, 200)

const appInit = function() {
  onWindowResize()
  $(window).on('resize', onWindowResizeThrottle)
}

const appDestroy = function() {
  $(window).off('resize', onWindowResizeThrottle)
}
*/

const init = function() {
  //if(window.app.isTouch()){
  $('[' + dataAttr + ']').each(function(index) {
    const spInstance = new ParallaxSection(this, {index: index})
    sectionParallaxInstances.push(spInstance)
  })
}

const destroy = function() {
  //if(window.app.isTouch()){
  sectionParallaxInstances.forEach(spInstance => {
    spInstance.destroy()
  })
  sectionParallaxInstances = []
}

export default {init, destroy}
